import * as R from 'ramda'

// ict or single domain admin
export const isAdmin = R.anyPass([
  R.pathEq(['role', 'code'], 'ictAdmin'),
  R.pathEq(['role', 'code'], 'admin'),
])
export const isAdminRoleId = R.either(
  R.equals(4),
  R.equals(3),
)
export const isIctAdminRoleId = R.equals(4)

export const isAdministratorRoleId = R.equals(3)
export const isContributorRoleId = R.equals(2)

export const isIctAdministrator = R.pathEq(['role', 'code'], 'ictAdmin')
export const isAdministrator = R.pathEq(['role', 'code'], 'admin')
export const isContributor = R.pathEq(['role', 'code'], 'contrib')
export const isExternalContributor = R.pathEq(['role', 'code'], 'extContrib')
export const isViewer = R.pathEq(['role', 'code'], 'viewer')

export const hasProfileEnabled = application => R.pathEq(['userProfile', application], true)
